import React from 'react';
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import pump from '../../assets/images/pump.png';

function newIcon(image) {
  const url = image;
  const iconMarker = new L.Icon({
    // iconUrl: require('../../assets/images/pump.png'),
    iconUrl: url,
    iconAnchor: [25, 50],
    popupAnchor: [0, -40],
    iconSize: new L.Point(80, 80),
  });
  return iconMarker;
}
function Markers({ data, isActive }) {
  const map = useMap();

  return (
    data.length > 0 &&
    data.map((marker, index) => {
      return (
        <Marker
          key={index}
          eventHandlers={{
            click: (e) => {
              map.flyTo([marker.latitude, marker.longitude], 14, {
                animate: true,
                duration: 0.8,
              });
            },
          }}
          position={{
            lat: marker.latitude,
            lng: marker.longitude,
          }}
          icon={newIcon(marker.image ? marker.image : pump)}
        ></Marker>
      );
    })
  );
}

const Map = ({ devices }) => {
  const positionCenter =
    devices.length > 0 ? [devices[0].latitude, devices[0].longitude] : [0, 0];
  const data = [...devices].reverse();
  return (
    <MapContainer
      center={positionCenter}
      zoom={2}
      id="mapID"
      markerZoomAnimation={true}
      maxZoom={18}
      minZoom={2}
      closePopupOnClick={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {data?.map((data, idx) => (
        <Markers data={[data]} isActive key={idx} />
      ))}
    </MapContainer>
  );
};

export default Map;
